import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import LeadershipNetLogo from '../Ln_logo/LeadershipNetLogo/LeadershipNetLogo'
import './header.scss'

const Header = () => {
  const location = useLocation()
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(false)
  }, [location.pathname])

  useEffect(() => {
    const mq = window.matchMedia('(min-width: 981px)')

    const handleChange = (event) => {
      if (event.matches) setOpen(false)
    }

    handleChange(mq)

    if (mq.addEventListener) mq.addEventListener('change', handleChange)
    else mq.addListener(handleChange)

    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', handleChange)
      else mq.removeListener(handleChange)
    }
  }, [])

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [])

  useEffect(() => {
    document.body.classList.toggle('drawer-open', open)
    return () => document.body.classList.remove('drawer-open')
  }, [open])

  const close = () => setOpen(false)
  const toggle = () => setOpen((value) => !value)

  return (
    <header className={`site-header ${open ? 'is-drawerOpen' : ''}`} role="banner">
      <div className="site-header__inner">
        <div className="site-header__brand">
          <LeadershipNetLogo />
        </div>

        <nav className="site-header__nav" aria-label="Primary">
          <a
            className="site-header__link site-header__link--external"
            href="https://leaderbridge.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            LeaderBridge
          </a>
        </nav>

        <button
          className="site-header__burger"
          type="button"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="mobile-drawer"
          onClick={toggle}
        >
          <span className="burger" aria-hidden="true">
            <span />
            <span />
            <span />
          </span>
        </button>
      </div>

      <div className="site-drawerOverlay" role="presentation" onClick={close} aria-hidden={!open} />

      <aside
        id="mobile-drawer"
        className="site-drawer"
        aria-label="Mobile navigation"
        aria-hidden={!open}
      >
        <div className="site-drawer__top">
          <div className="site-drawer__brand">
            <LeadershipNetLogo />
          </div>

          <button
            className="site-drawer__close"
            type="button"
            onClick={close}
            aria-label="Close menu"
          >
            Close
          </button>
        </div>

        <nav className="site-drawer__nav" aria-label="Mobile Primary">
          <a
            className="site-drawer__link site-drawer__link--cta"
            href="https://leaderbridge.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={close}
          >
            <span>LeaderBridge</span>
            <span aria-hidden="true">↗</span>
          </a>
        </nav>
      </aside>
    </header>
  )
}

export default Header
